import React, { Suspense, useEffect, useState } from "react";
import { Route, Navigate, Routes } from "react-router-dom";

import Footer from "../components/footer/footer";
import CertificationsRoutes from "../routes/certifications-routes";
import { RootState } from "../redux/store";
import { useSelector } from "react-redux";
import LoadingComp from "../components/re-usable/loading/loading";
import SvgIcons from "../components/re-usable/icons/svg-icons";
import useRawRedirectUrls from "../hooks/useRawRedirectUrls";

const RedirectUrlAllPage = React.lazy(() => import("../pages/redirects/redirect-all"));

type RedirectUrlType = {
  oldUrl: string;
  newUrl: string;
};

const CertificationsLayout = () => {
  const { redirectUrls } = useRawRedirectUrls();
  const allRedirectUrls = useSelector((state: RootState) => state.allRedirectUrls);
  const [redirectUrlList, setRedirectUrlList] = useState<RedirectUrlType[] | null>(redirectUrls?.redirectList ?? null);

  useEffect(() => {
    if (redirectUrls === null && allRedirectUrls.data.urlRedirectLists !== undefined) {
      setRedirectUrlList(allRedirectUrls.data.urlRedirectLists);
    }
  }, [allRedirectUrls.data]);

  if (redirectUrlList === null) return <LoadingComp />;

  return (
    <>
      <Suspense fallback={<LoadingComp />}>
        <Routes>
          {/*{ redirectUrlList?.map((route: RedirectUrlType, index: number) => {
              return (
                <Route
                  key={index}
                  path={route.oldUrl}
                  element={
                    route.newUrl.match(/^(https?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/) ? (
                      <RedirectUrlAllPage redirectUrl={route.newUrl} />
                    ) : (
                      <Navigate to={route.newUrl} replace />
                    )
                  }
                />
              );
            })}*/}
          {CertificationsRoutes.map((route, index) => {
            return route.component ? <Route key={index} path={route.path} element={route.component} /> : null;
          })}
        </Routes>
      </Suspense>
      <Footer />
      {/*<SvgIcons />*/}
    </>
  );
};

export default CertificationsLayout;
